import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// models
import { ApplicationSettings } from '../../../shared/models/application-settings';
import { Lot } from '../../../shared/models/lot';
import { PrebidOnProduct } from '../../../shared/models/prebid-on-product';
import { BuyerCatalog } from '../models/prebid';

// services
import { WebApiService } from '../../../shared/services/web-api.service';

@Injectable()
export class PrebidOnProductService {

  private apiPath: string;

  constructor(private appSettings: ApplicationSettings, private webApiService: WebApiService) {
    this.apiPath = this.appSettings.adminApi + 'buyerlevel';
  }

  getPrebids(buyerId: number): Observable<Array<BuyerCatalog>> {
    return this.webApiService.getList(this.apiPath + '/' + buyerId + '/prebidonproduct');
  }

  getPrebid(buyerId: number, prebidId: number): Observable<BuyerCatalog> {
    return this.webApiService.getSingle(this.apiPath + '/' + buyerId + '/prebidonproduct/' + prebidId);
  }

  save(buyerId: number, prebid: BuyerCatalog): Observable<any> {
    const url = this.apiPath + '/' + buyerId + '/prebidonproduct';
    return this.webApiService.save(url, prebid);
  }

  edit(buyerId: number, prebid: BuyerCatalog): Observable<any> {
    const url = this.apiPath + '/' + buyerId + '/prebidonproduct';
    return this.webApiService.editSingle(url, prebid);
  }

  delete(prebidId: number, buyerId: number): Observable<any> {
    const url = this.apiPath + '/' + buyerId + '/prebidonproduct';
    return this.webApiService.delete(url, prebidId);
  }

  getLots(buyerId: number, auctionClusterId: number, catalogId: number): Observable<Array<Lot>> {
    return this.webApiService.getList(`${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct/${catalogId}/lot`);
  }

  getProductLots(buyerId: number, auctionClusterId: number, productId: number): Observable<Array<Lot>> {
    return this.webApiService
    .getList(`${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct/product/${productId}/lot`);
  }

  getPrebidsOnProduct(buyerId: number, auctionClusterId: number, productId: number): Observable<Array<PrebidOnProduct>>
  {
    return this.webApiService
    .getList(`${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct/product/${productId}`);
  }

  getLot(buyerId: number, auctionClusterId: number, lotId: number): Observable<Lot> {
    return this.webApiService.getSingle(`${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct/lot/${lotId}`);
  }

  getPrebidOnProduct(buyerId: number, auctionClusterId: number, prebidOnProductId: number): Observable<PrebidOnProduct> {
    return this.webApiService.getSingle(`${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct/${prebidOnProductId}`);
  }

  saveLot(buyerId: number, auctionClusterId: number, lot: Lot): Observable<any> {
    const url = `${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct/lot`;
    return this.webApiService.save(url, lot);
  }

  saveLotForProduct(buyerId: number, auctionClusterId: number, productId, lot: Lot): Observable<any> {
    const url = `${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct/product/${productId}/lot`;
    return this.webApiService.save(url, lot);
  }

  savePrebidOnProductForProduct(buyerId: number, auctionClusterId: number, productId, prebidOnProduct: PrebidOnProduct): Observable<any> {
    const url = `${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct/product/${productId}`;
    return this.webApiService.save(url, prebidOnProduct);
  }

  editLot(buyerId: number, auctionClusterId: number, lot: Lot): Observable<any> {
    const url = `${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct/lot`;
    return this.webApiService.editSingle(url, lot);
  }

  editPrebidOnProduct(buyerId: number, auctionClusterId: number, prebidOnProduct: PrebidOnProduct): Observable<any> {
    const url = `${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct`;
    return this.webApiService.editSingle(url, prebidOnProduct);
  }

  deleteLot(buyerId: number, auctionClusterId: number, lotId: number): Observable<any> { 
    return this.webApiService.delete(`${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct/lot`, lotId);
  }

  deletePrebidOnProduct(buyerId: number, auctionClusterId: number, prebidOnProductId: number): Observable<any> { 
    return this.webApiService.delete(`${this.apiPath}/${buyerId}/auctioncluster/${auctionClusterId}/prebidonproduct`, prebidOnProductId);
  }
}
